import { render, staticRenderFns } from "./CreationServiceName.vue?vue&type=template&id=2242c50e&scoped=true&"
import script from "./CreationServiceName.vue?vue&type=script&lang=js&"
export * from "./CreationServiceName.vue?vue&type=script&lang=js&"
import style0 from "./CreationServiceName.vue?vue&type=style&index=0&id=2242c50e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242c50e",
  null
  
)

export default component.exports